const CURRENCY_FORMATTER = new Intl.NumberFormat(undefined, {
    currency: "INR",
    style: "currency"
});
export function FormatCurrency(number: number) {

    if (number === 0) {
        return ''; // or return ''
    } else {
        return CURRENCY_FORMATTER.format(number);
    }

}



